import Cookies from "js-cookie"
import {MessageBannerItem, MessageBannerPlacements, MessageBannerPersonalisedItems} from "../../models/messageBanner"
import {MESSAGE_BANNER_TYPE, MASID_COOKIE_NAME} from "../../config/constants"

export const checkIfMasIdExists = (masId: string, masIDCookie: string | undefined): boolean => {
    return !!masIDCookie?.split("|").includes(masId)
}

export const filterPersonalizedContent = (
    items: MessageBannerPersonalisedItems[],
    masIDCookie: string | undefined,
): MessageBannerItem[] => {
    return (
        items?.flatMap(item => {
            if (item?.type !== MESSAGE_BANNER_TYPE.PERSONALISED_CONTENT_TYPE) return []

            const matchingRule = item?.rules?.find(rule => checkIfMasIdExists(rule.masId, masIDCookie))
            return matchingRule?.content || item?.defaultContent || []
        }) || []
    )
}

export const getPersonalizedBanners = (placements: MessageBannerPlacements[]): MessageBannerItem[] => {
    try {
        const masIDCookie = Cookies.get(MASID_COOKIE_NAME)?.split("=")[1]

        const topBanner = placements?.find(({name}) => name === MESSAGE_BANNER_TYPE.PLACEMENT_TOP_BANNER)
        const items = topBanner?.content?.flatMap(({items}) => items) || []

        const nonPersonalizedItems = items?.filter(item => item?.type === MESSAGE_BANNER_TYPE.TEASER_TYPE) || []
        const personalizedItems = filterPersonalizedContent(items, masIDCookie) || []

        return [...nonPersonalizedItems, ...personalizedItems]
    } catch (error) {
        return []
    }
}

export default getPersonalizedBanners
